import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';

import LANGUAGES_CONTROLLER from '../../controllers/languages';
import NoData from '../page/NoData';
import { ErrorKind } from '../../utils/enums';
import PaginationComponent from '../page/Pagination';
import Logger, { LOG_LEVELS } from '../../utils/logger';

const FORM_NAME = 'EXISTING_SUB_CATEGORIES';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

const NoDataComponent = (props) => {
    return (
        <NoData noDataText="errorAndWarnings_NoData" {...props} />
    );
};

const ROW_ACTIONS = {
    VIEW_AND_RESOLVE: 'VIEW_AND_RESOLVE'
};

export class ExistingSubCategories extends React.Component {

    constructor(props) {
        super(props);
        log.debug('Creating Component: ExistingSubCategories');

        this.state = {
            viewTableState: {},
            pagination: {
                pageNumber: 1,
                pageSize: 10
            }
        };
        //Functions with this component binding
        this.onActionClickHandler = this.onActionClickHandler.bind(this);
        this.onFetchDataHandler = this.onFetchDataHandler.bind(this);
    }

    onFetchDataHandler(state) {
        log.debug('onFetchDataHandler(): ');
        let { page, pageSize } = state;
        pageSize = Object.is(pageSize, NaN) ? 10 : pageSize;
        page = Object.is(page, NaN) ? 0 : page;
        let pagination = Object.assign({}, this.state.pagination, {
            pageNumber: page + 1,
            pageSize: pageSize
        });
        this.setState({
            pagination: pagination,
            viewTableState: state
        });

        this.props.onFetchData(pagination, this.props.categoryRowData);
    }

    getPages(totalCount, pageSize = 10) {
        if (totalCount < 1 || pageSize < 1) {
            return 1;
        }
        let pages = Math.ceil(totalCount / pageSize);
        return pages < 1 ? 1 : pages;
    }

    onActionClickHandler(action, data) {
        log.debug('onActionClickHandler(): ', action, data);
        return (event) => {
            log.debug('onActionClickHandler():callback(): ', event);
            if (typeof this.props.onActionClick === 'function') {
                this.props.onActionClick(this.props.type, action, data, event);
            }
        }
    }

    render() {
        log.debug('render(): ', this.props);
        const data = this.props.categoryRowData.original.subCategories || [];
        const pagination = this.state.pagination || {};
        const tableOptions = this.props.tableOptions || {};
        const columns = [
            {
                accessor: 'spacer',
                headerClassName: 'invisible',
                width: 35
            },
            {
                accessor: 'subTypeSearchValue',
                headerClassName: 'invisible',
                Cell: row => (
                    <div>
                        <span>{`${row.value}`}</span>
                        <span className='ml30'>{`${row.original.totalItemsCount}`}</span>
                    </div>
                )
            },
            {
                accessor: 'actions',
                headerClassName: 'invisible',
                minWidth: 165,
                width: 165,
                Cell: row => (
                    <button className="link float-right">
                        <a onClick={this.onActionClickHandler(ROW_ACTIONS.VIEW_AND_RESOLVE, row)}>
                            {LANGUAGES_CONTROLLER.format(this.props.languages, 'existingSubCategories_ViewAndResolve')}
                        </a>
                    </button>

                )
            }
        ];

        return (
            <div data-test="component-existingSubCategories" className='ReactTableList'>
                <ReactTable
                    className="expand-table"
                    manual
                    minRows={1}
                    ref={(r) => this.viewTable = r}
                    data={data}
                    columns={columns}
                    defaultPageSize={pagination.pageSize || 10}
                    defaultFilterMethod={(filter, row) => String(row[filter.id]).includes(filter.value)}
                    {...tableOptions}
                    NoDataComponent={NoDataComponent}
                    pageSizeOptions={[10, 20, 50, 100]}
                    pages={pagination.pages || 1}
                    showPagination={data.length >= 10}
                    onFetchData={this.onFetchDataHandler}
                    showPageJump={false}
                    sortable={false}
                    PaginationComponent={PaginationComponent}
                    loading={this.props.loading}
                />
            </div>
        );
    }

    componentDidUpdate(prevProps) {
        log.debug('componentDidUpdate(): ', prevProps);

        if (this.props.categoryRowData !== prevProps.categoryRowData) {
            let pagination = Object.assign({}, this.state.pagination);
            let totalCount=0;
            const data = this.props.categoryRowData.original.subCategories || [];
            if (data.length > 0)
                totalCount = data[0].totalSubTypeCount;
            pagination.pages = this.getPages(totalCount, this.state.pagination.pageSize);
            this.setState({
                pagination: pagination
            })
        }
    }
}


ExistingSubCategories.defaultProps = {
    categoryRowData: {},
    type: ErrorKind.UNKNOWN,
    onActionClick: () => { },
    onFetchData: () => { },
    loading: false
};

function mapStateToProps(state) {
    log.debug('mapStateToProps(): ');
    let stateProps = {};
    stateProps.languages = state.languages;
    log.debug('mapStateToProps(): stateProps: ', stateProps);
    return stateProps;
}

function mapDispatchersToProps(dispatch) {
    log.debug('mapDispatchersToProps(): ');
    let dispatcherProps = {};
    log.debug('mapDispatchersToProps(): dispatcherProps: ', dispatcherProps);
    return dispatcherProps;
}

export default connect(mapStateToProps, mapDispatchersToProps)(ExistingSubCategories);
